import { Component } from '@angular/core';

@Component({
  selector: 'choose-us',
  templateUrl: './choose-us.component.html',
  styleUrls: ['./choose-us.component.scss']
})
export class ChooseUsComponent {

}
